// src/lib/ga.ts
const GA_ID = process.env.GATSBY_GA4_ID

const hasYes = (v: unknown) => {
    if (typeof v === 'string') v = v.toLowerCase()
    return (
        v === true ||
        v === 'yes' ||
        v === 'granted' ||
        v === '1' ||
        v === 'true'
    )
}

/** Bootstrap: dataLayer/gtag + Consent-Defaults (denied) — idempotent */
const ensureGtagBootstrap = () => {
    if (typeof window === 'undefined') return
    if (!window.dataLayer) window.dataLayer = []
    if (typeof window.gtag !== 'function') {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments as unknown as any)
        }
    }
    // Default nur einmal setzen
    if (!(window as any).__gaConsentDefaultSet) {
        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500,
        })
        ;(window as any).__gaConsentDefaultSet = true
    }
}

/** CookieYes → Consent Mode mappen (nur update, default wurde oben gesetzt) */
export const applyConsentFromCookieYes = () => {
    if (typeof window === 'undefined') return
    ensureGtagBootstrap()
    const cats = window.getCkyConsent?.().categories ?? {}
    const analyticsGranted = hasYes(cats.analytics)
    const adsGranted =
        hasYes(cats.advertisement) || hasYes((cats as any).marketing) || false

    window.gtag('consent', 'update', {
        analytics_storage: analyticsGranted ? 'granted' : 'denied',
        ad_storage: adsGranted ? 'granted' : 'denied',
        ad_user_data: adsGranted ? 'granted' : 'denied',
        ad_personalization: adsGranted ? 'granted' : 'denied',
    })
}

/** gtag.js IMMER laden (auch ohne Consent) → cookieless pings möglich */
export const loadGaOnce = (): Promise<void> =>
    new Promise((resolve, reject) => {
        if (typeof window === 'undefined') return resolve()
        ensureGtagBootstrap()
        if (window.__gaLoaded) return resolve()
        if (!GA_ID) return reject(new Error('Missing GATSBY_GA4_ID'))

        const s = document.createElement('script')
        s.async = true
        s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
        s.onload = () => {
            window.__gaLoaded = true
            window.gtag('js', new Date())
            // SPA-modus: wir feuern page_view manuell
            window.gtag('config', GA_ID, { send_page_view: false })
            resolve()
        }
        s.onerror = () => reject(new Error('Failed to load gtag.js'))
        document.head.appendChild(s)
    })

/** Pageview feuern (auch ohne Consent → cookieless ping) */
export const trackPageView = (url: string) => {
    if (typeof window === 'undefined' || !GA_ID) return
    ensureGtagBootstrap()
    window.gtag('event', 'page_view', {
        page_location: url,
        page_path: new URL(url, window.location.origin).pathname,
        page_title: document.title,
        // optional: debug only
        // debug_mode: true,
    })
}
